import { createBrowserRouter, Navigate } from "react-router-dom";
import { RootLayout } from "@/layouts/RootLayout";
import { ProtectedLayout } from "@/layouts/ProtectedLayout";
import { AccountLayout } from "@/layouts/AccountLayout";
import { ErrorPage } from "@/pages/ErrorPage";
import { NotFoundPage } from "@/pages/NotFoundPage";

import LoginPage from "@/app/login/page";
import SignupPage from "@/app/signup/page";
import SupportPage from "@/app/support/page";
import AssistantPage from "@/app/(pages)/assistant/page";
import AssistantChatPage from "@/app/(pages)/assistant/chat/[id]/page";
import ProjectsPage from "@/app/(pages)/projects/page";
import ProjectDetailPage from "@/app/(pages)/projects/[id]/page";
import ProjectAssistantPage from "@/app/(pages)/projects/[id]/assistant/page";
import ProjectAssistantChatPage from "@/app/(pages)/projects/[id]/assistant/chat/[chatId]/page";
import ProjectTabularReviewsPage from "@/app/(pages)/projects/[id]/tabular-reviews/page";
import ProjectTabularReviewPage from "@/app/(pages)/projects/[id]/tabular-reviews/[reviewId]/page";
import ProjectLauraPage from "@/app/(pages)/projects/[id]/laura/page";
import ProjectLauraAuditPage from "@/app/(pages)/projects/[id]/laura/[auditId]/page";
import TabularReviewsPage from "@/app/(pages)/tabular-reviews/page";
import TabularReviewPage from "@/app/(pages)/tabular-reviews/[id]/page";
import WorkflowsPage from "@/app/(pages)/workflows/page";
import WorkflowDetailPage from "@/app/(pages)/workflows/[id]/page";
import LauraPage from "@/app/(pages)/laura/page";
import LauraAuditPage from "@/app/(pages)/laura/[id]/page";
import AccountPage from "@/app/(pages)/account/page";
import ModelsAndApiKeysPage from "@/app/(pages)/account/models/page";
import AccountLauraPage from "@/app/(pages)/account/laura/page";

export const router = createBrowserRouter([
    {
        element: <RootLayout />,
        errorElement: <ErrorPage />,
        children: [
            { index: true, element: <Navigate to="/assistant" replace /> },
            { path: "login", element: <LoginPage /> },
            { path: "signup", element: <SignupPage /> },
            { path: "support", element: <SupportPage /> },
            {
                element: <ProtectedLayout />,
                children: [
                    { path: "assistant", element: <AssistantPage /> },
                    {
                        path: "assistant/chat/:id",
                        element: <AssistantChatPage />,
                    },
                    { path: "projects", element: <ProjectsPage /> },
                    { path: "projects/:id", element: <ProjectDetailPage /> },
                    {
                        path: "projects/:id/assistant",
                        element: <ProjectAssistantPage />,
                    },
                    {
                        path: "projects/:id/assistant/chat/:chatId",
                        element: <ProjectAssistantChatPage />,
                    },
                    {
                        path: "projects/:id/tabular-reviews",
                        element: <ProjectTabularReviewsPage />,
                    },
                    {
                        path: "projects/:id/tabular-reviews/:reviewId",
                        element: <ProjectTabularReviewPage />,
                    },
                    {
                        path: "projects/:id/laura",
                        element: <ProjectLauraPage />,
                    },
                    {
                        path: "projects/:id/laura/:auditId",
                        element: <ProjectLauraAuditPage />,
                    },
                    {
                        path: "tabular-reviews",
                        element: <TabularReviewsPage />,
                    },
                    {
                        path: "tabular-reviews/:id",
                        element: <TabularReviewPage />,
                    },
                    { path: "workflows", element: <WorkflowsPage /> },
                    {
                        path: "workflows/:id",
                        element: <WorkflowDetailPage />,
                    },
                    { path: "laura", element: <LauraPage /> },
                    { path: "laura/:id", element: <LauraAuditPage /> },
                    {
                        path: "account",
                        element: <AccountLayout />,
                        children: [
                            { index: true, element: <AccountPage /> },
                            {
                                path: "models",
                                element: <ModelsAndApiKeysPage />,
                            },
                            { path: "laura", element: <AccountLauraPage /> },
                        ],
                    },
                ],
            },
            { path: "*", element: <NotFoundPage /> },
        ],
    },
]);
